import general from '../../utils/general';
import { useState } from 'react';
import { translations, LanguageKeys } from './translation';

export const useController = () => {
    const [account, setAccount] = general.zustand((state: any) => [state.account, state.setAccount]);
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState<LanguageKeys>((general.getBrowserLanguage() == 'PTBR' ? 'PTBR' : 'EN') as LanguageKeys);
    const [choosingOptions, setChoosingOptions] = useState(true);
    const allLanguageCodes = general.languages.map((lang) => lang.code) as LanguageKeys[];

    const handleChange = (event: any) => {
        setLoginData({ ...loginData, [event.target.name]: event.target.value });
    }

    const login = async (event: any) => {
        event.preventDefault();
        setLoading(true);
        try {
            general.api.post('/account/login', loginData).then((response: any) => {
                setLoading(false);
                if (response.data.status === 200) {
                    let accountData = response.data.data.account;
                    accountData.token = response.data.data.token;
                    setAccount(accountData);
                    localStorage.setItem("token", response.data.data.token);
                    localStorage.setItem("account", JSON.stringify(response.data.data.account));
                    general.GoToRoute('/')
                }
                else {
                    general.toast.error(response.data.message);
                }
            })
                .catch((err: any) => {
                    setLoading(false);
                    general.toast.error(translations[currentLanguage]?.error ?? 'Error');
                    console.log(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
        catch (err) {
            setLoading(false);
            general.toast.error(translations[currentLanguage]?.error ?? 'Error');
            console.log(err);
        }
    }

    return { 
        general,
        login, 
        handleChange, 
        currentLanguage,
        loading 
    }
}

export default useController;